<template>
    <main class="main">
        <div class="container">
            <div class="row mb-3">
                <div class="col-md-6 col-12">
                    <h1 class="page-title h1" v-text="'Komunikaty'" />
                </div>
                <div
                    class="col-md-6 mt-md-0 col-12 mt-2 text-right"
                    v-if="news && news.length"
                >
                    <button
                        class="btn btn-outline-custom"
                        @click="$store.dispatch('markAllNewsAsRead')"
                    >
                        <span>Oznacz wszystkie jako przeczytane</span>
                    </button>
                </div>
            </div>

            <div class="row">
                <div class="col-md-3">
                    <div class="card notifications-card">
                        <div class="card-body text-sm">
                            <figure class="text-center">
                                <img
                                    class="img-fluid"
                                    :src="
                                        require('@/assets/img/notifications.svg')
                                    "
                                />
                            </figure>
                            <p>
                                {{
                                    this.$brand.notifications.notificationsDesc
                                }}
                            </p>
                        </div>
                    </div>
                    <the-filters
                        @applyFilters="onFiltersApply"
                        :filters="filters"
                        :moduleName="'news'"
                    />
                </div>
                <div class="col-md-9">
                    <page-preloader
                        v-if="newsStatus === 'loading'"
                    ></page-preloader>
                    <div v-else class="richTable-body">
                        <template v-if="news && news.length">
                            <notification-preview
                                v-for="(item, idx) in news"
                                :key="idx"
                                class="richTable-row message"
                                :data="item"
                                :idx="idx"
                            />
                        </template>
                        <template v-else> Brak powiadomień </template>
                    </div>
                    <the-pagination
                        v-if="
                            pagination.total &&
                                pagination.total > pagination.limit
                        "
                        :current="pagination.offset / pagination.limit + 1"
                        :total="pagination.totalPages"
                        :perPage="pagination.limit"
                        :on-change="onChange"
                    />
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import NotificationPreview from '@/components/notifications/NotificationPreview.vue'

export default {
    components: {
        NotificationPreview
    },
    methods: {
        onFiltersApply() {
            if (this.newsFetchTimeout) clearTimeout(this.newsFetchTimeout)
            this.newsFetchTimeout = setTimeout(() => {
                this.fetch()
            }, 100)
        },
        fetch() {
            return this.$store.dispatch('newsFetch')
        },
        onChange(page) {
            this.$router.push({ query: { ...this.$route.query, page: page } })
        }
    },
    computed: {
        filters() {
            return this.$store.getters.getNewsFilters
        },
        news() {
            return this.$store.getters.getNews
        },
        newsHeader() {
            return this.$store.getters.getNewsHeader
        },
        newsStatus() {
            return this.$store.getters.getNewsStatus
        },
        pagination() {
            return this.$store.getters.getNewsPagination
        },
        activeNews() {
            return this.$store.getters.getActiveNews
        }
    },
    created() {
        this.$nextTick(() => {
            if (this.newsHeader) {
                this.fetch().then(() => {
                    // fetch once again to update header news
                    this.$store
                        .dispatch('newsFetch', {
                            limit: 5,
                            offset: 0
                        })
                        .then(() => {
                            if (this.activeNews) {
                                this.$store.dispatch(
                                    'markOneNewsAsRead',
                                    this.activeNews
                                )
                            }
                        })
                })
            }
        })
    },
    mounted() {
        if (this.activeNews) {
            const el = document.querySelector(`#message-${this.activeNews}`)
            const headerHeight = document.querySelector('header').offsetHeight
            this.$scrollTo(el, 400, {
                offset: -headerHeight - 25
            })
        }
    },
    data() {
        return {
            newsFetchTimeout: null
        }
    }
}
</script>

<style lang="scss">
.message-header {
    svg {
        width: 100%;
    }
}
</style>
